<template>
  <div
    v-loading.fullscreen="isRequesting"
    element-loading-text="サーバーに問い合わせています">
    <section class="settings section app-section">
      <header class="app-header">
        <h2 class="app-h2">サイト設定</h2>
      </header>
      <template v-if="isInitialized">
        <el-form :model="settings" class="p2">
          <ul class="section-list p2">
            <template v-for="(setting, index) in defaultSettings">
              <li class="section-item pb2">
                <h3 class="section-h3 pl1">{{ setting.meta.heading }}</h3>
                <div class="px2">
                  <p class="section-p">{{ setting.meta.description }}</p>

                  <template v-for="(item, key) in setting">
                    <template v-if="key !== 'meta' && typeof settings[index][key] !== 'undefined'">

                      <!-- 画像の場合 -->
                      <template v-if="!item.type && !item.name && item.meta && item.meta.image">
                        <h4 class="section-h4">{{ item.meta.heading }}</h4>
                        <p class="section-p">{{ item.meta.description }}</p>
                        <el-button @click="onSelectImage(index, key, settings[index][key])">画像の選択</el-button>
                        <div class="image-info flex column justify-between items-center">
                          <img class="image-info-img" :src="settings[index][key]['src']">
                          <p class="image-info-size">画像のサイズ：{{ settings[index][key]['width'] }}x{{ settings[index][key]['height'] }}</p>
                        </div>
                      </template>

                      <template v-if="setting.meta && setting.meta.image">
                        <template v-if="key === 'src'">
                          <el-button @click="onSelectImage(index, null, settings[index])">画像の選択</el-button>
                          <div class="image-info flex column justify-between items-center">
                            <img class="image-info-img" :src="settings[index]['src']">
                            <p class="image-info-size">画像のサイズ：{{ settings[index]['width'] }}x{{ settings[index]['height'] }}</p>
                          </div>
                        </template>
                      </template>
                      <!-- <div v-if="item.meta && item.meta.image">
                        <div class="image-info flex column justify-between items-center">
                          <img class="image-info-img" :src="settings[index]['src']">
                          <p class="image-info-size">画像のサイズ：{{ settings[index]['width'] }}x{{ settings[index]['height'] }}</p>
                        </div>
                      </div> -->

                      <template v-if="setting.meta && !setting.meta.image">
                        <div v-if="item.type === 'number' || item.type === 'text'">
                          <div class="stacked-label my1">
                            <el-form-item :label="item.name">
                              <el-input :type="item.type" v-model="settings[index][key]" :placeholder="item.default ? '例: ' + item.default : '例: ' + item.placeholder" :readonly="item.readonly"></el-input>
                            </el-form-item>
                          </div>
                        </div>

                        <div v-if="item.type === 'checkbox'">
                          <h5>{{ item.name }}</h5>
                          <template v-for="(checkbox, i) in item.values">
                            <el-checkbox v-model="settings[index][key][i]" :label="checkbox.name" :key="i"></el-checkbox>
                          </template>
                        </div>
                      </template>

                    </template>
                  </template>
                </div>
              </li>
            </template>
            <div class=button-wrapper>
              <el-button type=primary class="primary raised round" @click="submit" :loading="isRequesting">更新</el-button>
            </div>
          </ul>
        </el-form>
      </template>
    </section>

    <section>
      <template v-if="themes">
        <template v-for="type in ['navigation', 'sidebar', 'footer']">
          <template v-if="themes[type] && themes[type].id">
            <div :is="getComponentNameById(themes[type].id)"
              :component="themes[type]" :hide-all="true"
              preview-size="native"></div>
          </template>
        </template>
      </template>
    </section>

    <el-dialog width="90%" title="画像の選択" :visible.sync="dialogFormVisible">
      <select-image v-model="selectedImage" @change="onUpdateImage"></select-image>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">キャンセル</el-button>
        <el-button type="primary" @click="onUpdateImage">選択</el-button>
      </span>
    </el-dialog>

    <el-dialog width="50%" :title="error.title" :visible.sync="dialogErrorVisible">
      <span>{{ error.message }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogErrorVisible = false">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import RouteBase from '@/components/mixins/RouteBase'
import SelectImage from '@/components/app/SelectImage'
import AppAPI from '@/api'

export default {
  name: 'settings',
  mixins: [RouteBase],
  components: {
    'select-image': SelectImage
  },
  data: function () {
    return {
      checked: false,
      defaultSettings: AppAPI.settings,
      selectedImage: {
        key: null,
        subKey: null,
        id: 0
      },
      dialogFormVisible: false
    }
  },
  computed: {
  },
  methods: {
    /**
     * 「画像の選択」ボタンをクリックした場合にselectedImageに対応するプロパティを入れる
     */
    onSelectImage: function (key, subKey, image) {
      this.selectedImage.key = key
      this.selectedImage.subKey = subKey
      this.selectedImage.id = image ? image.id : 0
      this.dialogFormVisible = true
    },
    /**
     * 画像選択のダイアログで選択ボタンをクリックした場合に、対応するプロパティに選んだ画像情報を入れる
     */
    onUpdateImage: function () {
      const key = this.selectedImage.key
      const subKey = this.selectedImage.subKey
      const selected = this.media.find(image => image.id === this.selectedImage.id)

      if (subKey) {
        this.settings[key][subKey].id = selected.id
        this.settings[key][subKey].src = selected.source_url
        this.settings[key][subKey].width = selected.media_details.width
        this.settings[key][subKey].height = selected.media_details.height
      } else {
        this.settings[key].id = selected.id
        this.settings[key].src = selected.source_url
        this.settings[key].width = selected.media_details.width
        this.settings[key].height = selected.media_details.height
      }

      this.selectedImage.key = null
      this.selectedImage.subKey = null
      this.selectedImage.id = 0
      this.dialogFormVisible = false
    },
    /**
     * 更新ボタンをクリックしたらWPDBと同期する
     */
    submit: async function (ev) {
      this.isRequesting = true

      let responseSettings = await this.$store.dispatch('wordpress/settings/update', this.settings)

      // navigation/sidebar/footerコンポーネントを更新する
      this.$children.forEach(child => {
        if (!child.meta) return
        if (~['navigation', 'sidebar', 'footer'].indexOf(child.meta.type)) child.updateComponent()
      })

      let responseThemes = await this.$store.dispatch('wordpress/themes/update', this.themes)

      if (JSON.stringify(responseSettings) === JSON.stringify(this.settings) && JSON.stringify(responseThemes) === JSON.stringify(this.themes)) {
        this.$notify({
          title: '更新完了',
          message: 'サーバーデータを更新しました',
          type: 'success',
          duration: 1500
        })
      } else {
        this.$notify({
          title: '更新失敗',
          message: 'サーバーデータを更新できませんでした',
          type: 'error',
          duration: 1500
        })
      }

      this.isRequesting = false
    }
  },
  created: async function () {
    if (process.env.NODE_ENV !== 'production') console.log('On Settings created...')

    /**
     * navigationやfooterでpagesが必要になる
     * navigation/sidebar/footerコンポーネントが生成される前に
     * pagesを用意しておかないとrenderingできないため、requestThemesよりも
     * 前にpagesを取得しておく必要がある
     */
    this.isRequesting = true
    try { await this.requestMedia() } catch (error) { return false }
    try { await this.requestPages() } catch (error) { return false }
    try { await this.requestSettings() } catch (error) { return false }
    try { await this.requestThemes() } catch (error) { return false }
    this.isRequesting = false
    this.isInitialized = true
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

.el-input {
  width: 100%;
}

.button {
  &-wrapper {
    margin-top: 3em;
    text-align: center;
  }
}

.section {
  &-h3 {
    border-left: 4px solid $--color-primary;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/routes/Settings.vue